import React from "react"
import { MortgagePreferences } from "models/ApplicationSummaryEnhanced"

interface MortgageTermCopyProps {
  preference: MortgagePreferences["term"]
  isLendingIntoRetirement: boolean
}

const lendingIntoRetirementCopy =
  " You’re aware that this extends into your planned retirement age and have an appropriate plan in place to cover your monthly payments."

export const MortgageTermCopy = ({
  preference,
  isLendingIntoRetirement,
}: MortgageTermCopyProps) => {
  return (
    <>
      A term of{" "}
      <strong>
        {preference.years} years{preference.months ? `, ${preference.months} months` : ""}
      </strong>{" "}
      has been recommended because {preference.customReason}
      {isLendingIntoRetirement ? lendingIntoRetirementCopy : ""}
    </>
  )
}
